<mat-card appearance="outlined" class="mat-elevation-2">
  <mat-checkbox
    class="disableMosquitoCheckbox"
    [(ngModel)]="mosquito"
    (change)="setMosquito($event.checked)"
    >{{ 'MOSQUITO|Czy chcesz siatkę' | translate }}</mat-checkbox
    >
  </mat-card>
  @if (mosquito) {
    <mat-card appearance="outlined" class="mat-elevation-2">
      <h4>{{ 'MOSQUITO|Linia' | translate }}</h4>
      <div class="configuratorContentLines">
        <icc-list [items]="systems" itemTemplate="itemImgTitle" [scrollable]="false" [selected]="mosquito.System.id" (select)="setSystem($event)">
        </icc-list>
      </div>
      <h4>{{ 'MOSQUITO|Rozmiar' | translate }}</h4>
      <div class="configuratorContentStepsDefaultRight mosquite">
        <mat-form-field>
          <mat-label>{{ 'MOSQUITO|Szerokość (S)' | translate }}:</mat-label>
          <input matInput iccDimensionInput type="number" step="1" [(ngModel)]="mosquito.Width" (blur)="updateDimensions()">
          <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'MOSQUITO|Wysokość (H)' | translate }}:</mat-label>
          <input matInput iccDimensionInput type="number" step="1" [(ngModel)]="mosquito.Height" (blur)="updateDimensions()">
          <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
        </mat-form-field>
      </div>
      <div class="configuratorContentStepsDefaultDesc">
        <i class='fa fa-info-circle'></i>
        <span>{{ 'MOSQUITO|Podane wymiary są wymiarami zewnętrznymi moskitiery (z uwzględnieniem profilu dodatkowego, jeśli będzie wybrany)' | translate }}</span>
      </div>
      @if (types && types.length) {
        <div>
          <h4>{{ 'MOSQUITO|Typ' | translate }}</h4>
          <div class="configuratorContentLines">
            <icc-list [items]="types" itemTemplate="itemImgTitle" [scrollable]="false" [selected]="mosquito.Type.id" (select)="setType($event)">
            </icc-list>
          </div>
          @if (mosquito.Type.has_direction) {
            <div class="configuratorContentLines">
              <strong>{{ 'MOSQUITO|Wybierz stronę mocowania zawiasów:' | translate }}</strong>
              <mat-radio-group [(ngModel)]="mosquito.Direction">
                <mat-radio-button value="left">{{ 'INTERFACE|Lewa' | translate }}</mat-radio-button>
                <mat-radio-button value="right">{{ 'INTERFACE|Prawa' | translate }}</mat-radio-button>
              </mat-radio-group>
            </div>
          }
        </div>
      }
      <h4>{{ 'MOSQUITO|Kolor' | translate }}</h4>
      <div>
        @for (type of ['frame', 'net', 'panel']; track type) {
          @if (type !== 'panel' || mosquito.Type.extra_color) {
            <div>
              <icc-select-box
                    [title]="type === 'frame'
                        ? ('MOSQUITO|Kolor ramki moskitiery'| translate)
                        : type === 'net'
                        ? ('MOSQUITO|Kolor siatki'| translate)
                        : ('MOSQUITO|Kolor elementów z tworzywa'| translate)"
                [description]="mosquito?.Colors[type].name"
                [imageUrl]="mosquito?.Colors[type].color_img ? ('/files/windowcolor/' + mosquito?.Colors[type].color_img) : 'none'"
                [color]="'#' + mosquito?.Colors[type].color"
                [colorSelect]="true"
                [buttonText]="'INTERFACE|Zmień' | translate"
                (select)="openModalColor(type, mosquito?.Colors[type])"
              ></icc-select-box>
            </div>
          }
        }
      </div>
      @if ((montages && montages.length)
        || mosquito.Type.profile_position
        || mosquito.Type.muntin_position
        || (windowLines[mosquito.System.id] && mosquitoHoldersWidth)) {
        <div
          >
          @if (montages && montages.length) {
            <div class="configuratorContentLines">
              <h4>{{ 'MOSQUITO|System montażu' | translate }}</h4>
              <icc-list [items]="montages" itemTemplate="itemImgTitle" [scrollable]="false" [selected]="mosquito.Montage.id" (select)="setMontage($event)">
              </icc-list>
            </div>
          }
          @if (mosquito.Type.profile_position) {
            <div class="box-form">
              <strong>{{ 'MOSQUITO|Wybierz z której strony ma się znajdować profil dodatkowy:'| translate }}</strong>
              <mat-checkbox id="up_p" type="checkbox" name="profile_position[]" [(ngModel)]="mosquito.ProfilePositions.up">{{ 'INTERFACE|Góra'| translate }}</mat-checkbox>
              <mat-checkbox id="down_p" type="checkbox" name="profile_position[]" [(ngModel)]="mosquito.ProfilePositions.down">{{ 'INTERFACE|Dół'| translate }}</mat-checkbox>
              <mat-checkbox id="left_p" type="checkbox" name="profile_position[]" [(ngModel)]="mosquito.ProfilePositions.left">{{ 'INTERFACE|Lewa'| translate }}</mat-checkbox>
              <mat-checkbox id="right_p" type="checkbox" name="profile_position[]" [(ngModel)]="mosquito.ProfilePositions.right">{{ 'INTERFACE|Prawa'| translate }}</mat-checkbox>
            </div>
          }
          @if (mosquito.Type.muntin_position) {
            <div>
              <strong>{{ 'MOSQUITO|Wysokość szprosu'| translate }}</strong>
              <mat-radio-group [(ngModel)]="mosquito.MuntinType" (change)="mosquito.MuntinPosition = mosquito.Type.muntin_position">
                <mat-radio-button value="standard"><span>{{ 'MOSQUITO|Standardowa'| translate }}</span> ({{mosquito.Type.muntin_position | unitmm:1 }})</mat-radio-button>
                <mat-radio-button value="custom">{{ 'MOSQUITO|Inna wysokość'| translate }} ({{dimensionUnit.unitSymbol}}):</mat-radio-button>
              </mat-radio-group>
              @if (mosquito.MuntinType == 'custom') {
                <mat-form-field>
                  <mat-label>{{ 'MOSQUITO|Inna wysokość' | translate }}:</mat-label>
                  <input matInput iccDimensionInput type="number" step="1" name="muntin-position" [(ngModel)]="mosquito.MuntinPosition">
                  <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
                </mat-form-field>
              }
            </div>
          }
        </div>
      }
    </mat-card>
  }